import React, { useEffect, useState, useContext } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Card, CardHeader } from "@mui/material";
import AccountingApi from "../../../Classes/API/AccountingApi";
import DataTable from "examples/Tables/DataTable";
import Pagination from "@mui/material/Pagination";
import MDBox from "components/MDBox";
import { LanguageContext } from "App";
import MDTypography from "components/MDTypography";
import { useNavigate } from "react-router-dom";
import SearchPatientAnalysis from "../../../Classes/Models/Requests/Accounting/SearchPatientAnalysis";
import PatientAnalyticsSearch from "./SearchPatientAnalyitcs";
import MDButton from "components/MDButton";
import { IconButton } from "@mui/material";
import Swal from "sweetalert2";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
const index = () => {
  let navigate = useNavigate();
  let req = new SearchPatientAnalysis();
  const { translations } = useContext(LanguageContext);
  const [SearchReq, setSearchReq] = useState(new SearchPatientAnalysis());
  const [ResponseData, setResposneData] = useState({});
  const [IsLoaded, setIsLoaded] = useState(false);
  const [TableDataRows, setTableDataRows] = useState([]);
  const [Page, setPage] = useState(1);
  const [TotalPages, setTotalPages] = useState(0);

  const [sortOrder, setSortOrder] = useState(null); // 'asc' or 'desc'
  const [sortBy, setSortBy] = useState();
  const [Id, setId] = useState();
  const [UserName, setUserName] = useState();
  const [TotalSessions, setTotalSessions] = useState();
  const [Admitted, setAdmitted] = useState();
  const [Appointments, setAppointments] = useState();
  const [Exceptions, setExceptions] = useState();
  const [IsClicks, setIsClicks] = useState(false);

  const onSearchClick = async () => {
    req.id = Id;
    req.name = UserName;
    req.sessionsCount = TotalSessions;
    req.admittedSessionsCount = Admitted;
    req.appointmentSessionsCount = Appointments;
    req.exceptionCount = Exceptions;
    req.sortBy = sortBy;
    req.sortOrder = sortOrder;

    setSearchReq(req);
  };

  useEffect(() => {
    onSearchClick();
  }, [sortBy, sortOrder]);

  // State to manage sorting for each column
  const [sortState, setSortState] = useState({
    id: { order: "asc", isClicked: false },
    SessionsCount: { order: "asc", isClicked: false },
    AppointmentSessionsCount: { order: "asc", isClicked: false },
    AdmittedSessionsCount: { order: "asc", isClicked: false },
    ExceptionCount: { order: "asc", isClicked: false },
  });

  const handleSort = (column) => {
    setSortState((prevSortState) => {
      Swal.fire({
        title: "Please wait",
        text: "Loading...",
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
      // Toggle the sort order and set isClicked to true for the selected column
      const newOrder = prevSortState[column].order === "asc" ? "desc" : "asc";

      // Reset the state for all columns except the current one
      const updatedSortState = Object.keys(prevSortState).reduce((acc, key) => {
        acc[key] =
          key === column
            ? { order: newOrder, isClicked: true }
            : { order: prevSortState[key].order, isClicked: false };
        return acc;
      }, {});
      setTimeout(() => {
        Swal.close();
      }, 6000);

      return updatedSortState;
    });
  };

  const TableColumns = [
    {
      Header: (
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <span>{translations.SearchPatientAnalyticstableUser}</span>
          <div style={{ display: "flex", alignItems: "center" }}>
            <MDButton onClick={() => setSortBy("id")}>
              <IconButton
                onClick={() => handleSort("id")}
                style={{
                  backgroundColor: sortState.id.isClicked ? "gray" : "black",
                  color: "white",
                }}
              >
                {sortState.id.order === "asc" ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
              </IconButton>
            </MDButton>
          </div>
        </div>
      ),
      accessor: "User",
      align: "left",
    },
    {
      Header: (
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <span>{translations.SearchPatientAnalyticstableTotalSessions}</span>
          <div style={{ display: "flex", alignItems: "center" }}>
            <MDButton onClick={() => setSortBy("SessionsCount")}>
              <IconButton
                onClick={() => handleSort("SessionsCount")}
                style={{
                  backgroundColor: sortState.SessionsCount.isClicked ? "gray" : "black",
                  color: "white",
                }}
              >
                {sortState.SessionsCount.order === "asc" ? (
                  <KeyboardArrowUpIcon />
                ) : (
                  <KeyboardArrowDownIcon />
                )}
              </IconButton>
            </MDButton>
          </div>
        </div>
      ),
      accessor: "TotalSessions",
      align: "left",
    },
    {
      Header: (
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <span>{translations.SearchPatientAnalyticstableAppointments}</span>
          <div style={{ display: "flex", alignItems: "center" }}>
            <MDButton onClick={() => setSortBy("AppointmentSessionsCount")}>
              <IconButton
                onClick={() => handleSort("AppointmentSessionsCount")}
                style={{
                  backgroundColor: sortState.AppointmentSessionsCount.isClicked ? "gray" : "black",
                  color: "white",
                }}
              >
                {sortState.AppointmentSessionsCount.order === "asc" ? (
                  <KeyboardArrowUpIcon />
                ) : (
                  <KeyboardArrowDownIcon />
                )}
              </IconButton>
            </MDButton>
          </div>
        </div>
      ),
      accessor: "Appointments",
      align: "left",
    },
    {
      Header: (
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <span>{translations.SearchPatientAnalyticstableAdmitted}</span>
          <div style={{ display: "flex", alignItems: "center" }}>
            <MDButton onClick={() => setSortBy("AdmittedSessionsCount")}>
              <IconButton
                onClick={() => handleSort("AdmittedSessionsCount")}
                style={{
                  backgroundColor: sortState.AdmittedSessionsCount.isClicked ? "gray" : "black",
                  color: "white",
                }}
              >
                {sortState.AdmittedSessionsCount.order === "asc" ? (
                  <KeyboardArrowUpIcon />
                ) : (
                  <KeyboardArrowDownIcon />
                )}
              </IconButton>
            </MDButton>
          </div>
        </div>
      ),
      accessor: "Admitted",
      align: "left",
    },
    {
      Header: (
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <span>{translations.SearchPatientAnalyticstableExceptions}</span>
          <div style={{ display: "flex", alignItems: "center" }}>
            <MDButton onClick={() => setSortBy("ExceptionCount")}>
              <IconButton
                onClick={() => handleSort("ExceptionCount")}
                style={{
                  backgroundColor: sortState.ExceptionCount.isClicked ? "gray" : "black",
                  color: "white",
                }}
              >
                {sortState.ExceptionCount.order === "asc" ? (
                  <KeyboardArrowUpIcon />
                ) : (
                  <KeyboardArrowDownIcon />
                )}
              </IconButton>
            </MDButton>
          </div>
        </div>
      ),
      accessor: "Exceptions",
      align: "left",
    },
  ];

  const MakeTableRow = (log) => {
    return {
      User: (
        <MDTypography variant="button" color="text" fontWeight="medium">
          {log.patient.getUser?.id} | {log.patient.getUser?.name}
        </MDTypography>
      ),

      TotalSessions: (
        <MDTypography variant="button" color="text" fontWeight="medium">
          {log.accountingSessionsCount}
        </MDTypography>
      ),

      Appointments: (
        <MDTypography variant="button" color="text" fontWeight="medium">
          {log.appointmentSessionsCount}
        </MDTypography>
      ),
      Admitted: (
        <MDTypography variant="button" color="text" fontWeight="medium">
          {log.admittedSessionsCount}
        </MDTypography>
      ),
      Exceptions: (
        <MDTypography variant="button" color="text" fontWeight="medium">
          {log.exceptionCount}
        </MDTypography>
      ),
    };
  };

  const RefreshTable = (resList) => {
    var rows = [];
    resList?.forEach((Entry) => {
      rows.push(MakeTableRow(Entry));
    });
    setTableDataRows(rows);
  };

  useEffect(async () => {
    if (Object.keys(ResponseData).length > 1) {
      RefreshTable(ResponseData.list);
    }
  }, [ResponseData]);

  useEffect(() => {
    //Check if data is loaded
    if (Object.keys(ResponseData).length > 0) {
      setIsLoaded(true);
    } else {
      setIsLoaded(false);
    }
  }, [ResponseData]);

  const onSearch = async () => {
    SearchReq.pagingParams.pageNumber = Page;
    SearchReq.pagingParams.pageSize = 10;
    console.log(SearchReq);
    let res = await AccountingApi.SearchPatientAnalysis(SearchReq);
    if (res.status == "Success") {
      console.log(res);
      setResposneData(res.data);
      setTotalPages(res.data.totalPages);
    } else {
      Swal.fire({
        icon: "error",
        text: res.status.message,
      });
    }
  };

  useEffect(() => {
    console.log(SearchReq);
    onSearch();
  }, [SearchReq]);

  useEffect(() => {
    onSearch();
  }, [Page]);

  if (!IsLoaded) {
    return (
      <div>
        <MDBox>
          <MDTypography component="a" variant="button" color="text" fontWeight="medium">
            Loading Log Data...
          </MDTypography>
        </MDBox>
      </div>
    );
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {/* <LogsSearch setSearchReq={setSearchReq} /> */}
      <PatientAnalyticsSearch setSearchReq={setSearchReq} />

      <Card className="mt-5">
        <MDBox
          mx={4}
          mt={-3}
          py={3}
          px={2}
          sx={{ backgroundColor: "#3560AD" }}
          bgColor="info"
          borderRadius="lg"
          coloredShadow="info"
        >
          <div className="text-center">
            <MDTypography variant="h6" color="white">
              {translations.SearchPatientAnalyticstablePatientAnalytics}
            </MDTypography>
          </div>
        </MDBox>
        <MDBox p={3}>
          <DataTable
            table={{ columns: TableColumns, rows: TableDataRows }}
            isSorted={false}
            entriesPerPage={false}
            showTotalEntries={false}
            noEndBorder
          />
        </MDBox>

        <div className="text-right mx-3 my-4">
          <Pagination
            count={TotalPages}
            color="primary"
            onChange={(e, num) => setPage(num)}
            className="float-right"
          />
        </div>
      </Card>
    </DashboardLayout>
  );
};

export default index;
